import { useState, useEffect } from "react";
import axios from "axios";
import { CaretDown, CaretUp } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const EscalaICAM = ({ cuantia }) => {
  const [escala, setEscala] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [resultado, setResultado] = useState(null);

  useEffect(() => {
    if (!cuantia || cuantia <= 0) return;
    const fetchEscala = async () => {
      try {
        const response = await axios.get(`${API}/escala-icam?cuantia=${cuantia}`);
        setEscala(response.data.escala || []);
        setResultado(response.data.resultado);
      } catch (error) {
        console.error('Error fetching escala:', error);
      }
    };
    fetchEscala();
  }, [cuantia]);

  if (!escala.length) return null;

  const visibleEscala = expanded ? escala : escala.filter(t => t.activo || escala.indexOf(t) < 5);

  return (
    <div className="bg-white border border-[#171717] rounded-none p-6 shadow-[4px_4px_0px_0px_rgba(23,23,23,1)]" data-testid="escala-icam-table">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-[#0A0A0A]" style={{ fontFamily: 'Playfair Display, serif' }}>
          Escala ICAM completa
        </h3>
        {resultado && (
          <span className="font-mono text-sm text-[#8B1A1A] font-semibold" style={{ fontFamily: 'IBM Plex Mono, monospace' }}>
            Tu cuantia: {cuantia?.toLocaleString('es-ES')}€ → {resultado.honorarios?.toLocaleString('es-ES', { minimumFractionDigits: 2 })}€
          </span>
        )}
      </div>
      
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b-2 border-[#171717] bg-[#F4F4F0]">
              <th className="text-left py-2 px-3 text-xs uppercase tracking-[0.15em] text-[#525252] font-normal">Desde</th>
              <th className="text-left py-2 px-3 text-xs uppercase tracking-[0.15em] text-[#525252] font-normal">Hasta</th>
              <th className="text-right py-2 px-3 text-xs uppercase tracking-[0.15em] text-[#525252] font-normal">Porcentaje</th>
              <th className="text-right py-2 px-3 text-xs uppercase tracking-[0.15em] text-[#525252] font-normal">Honorarios limite</th>
            </tr>
          </thead>
          <tbody>
            {visibleEscala.map((tramo, idx) => (
              <tr
                key={idx}
                className={`border-b border-[#E5E5E2] transition-colors ${
                  tramo.activo
                    ? 'bg-[#8B1A1A]/10 font-semibold'
                    : idx % 2 === 0 ? 'bg-white' : 'bg-[#FAFAF8]'
                }`}
                data-testid={tramo.activo ? "escala-tramo-activo" : undefined}
              >
                <td className="py-2 px-3 font-mono" style={{ fontFamily: 'IBM Plex Mono, monospace' }}>
                  {tramo.desde.toLocaleString('es-ES')}€
                </td>
                <td className="py-2 px-3 font-mono" style={{ fontFamily: 'IBM Plex Mono, monospace' }}>
                  {tramo.hasta.toLocaleString('es-ES')}€
                </td>
                <td className="py-2 px-3 font-mono text-right" style={{ fontFamily: 'IBM Plex Mono, monospace' }}>
                  {tramo.porcentaje.toFixed(1)}%
                </td>
                <td className={`py-2 px-3 font-mono text-right ${tramo.activo ? 'text-[#8B1A1A]' : ''}`} style={{ fontFamily: 'IBM Plex Mono, monospace' }}>
                  {tramo.honorarios_limite.toLocaleString('es-ES', { minimumFractionDigits: 2 })}€
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      {escala.length > 5 && (
        <button
          data-testid="escala-toggle-expand"
          onClick={() => setExpanded(!expanded)}
          className="mt-3 flex items-center gap-1 text-xs text-[#8B1A1A] hover:text-[#701515] font-mono uppercase tracking-[0.1em] transition-colors mx-auto"
        >
          {expanded ? <CaretUp size={14} /> : <CaretDown size={14} />}
          {expanded ? 'Ver menos' : `Ver los ${escala.length} tramos`}
        </button>
      )}
      
      <p className="text-[10px] text-[#A3A3A3] mt-3 text-center" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
        Fuente: Criterios orientadores de honorarios ICAM. El tramo de tu cuantia aparece resaltado.
      </p>
    </div>
  );
};

export default EscalaICAM;
